var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnClientsLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.625 13.625C13.9346 13.625 13.375 14.1846 13.375 14.875V24.875C13.375 25.5654 13.9346 26.125 14.625 26.125H24.4306V27.625H14.625C13.1062 27.625 11.875 26.3938 11.875 24.875V14.875C11.875 13.3562 13.1062 12.125 14.625 12.125H27.625C29.1438 12.125 30.375 13.3562 30.375 14.875V18.9417H28.875V14.875C28.875 14.1846 28.3154 13.625 27.625 13.625H14.625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.625 19.375H25.625C25.3489 19.375 25.125 19.5989 25.125 19.875V29.875C25.125 30.1511 25.3489 30.375 25.625 30.375H30.625C30.9011 30.375 31.125 30.1511 31.125 29.875V19.875C31.125 19.5989 30.9011 19.375 30.625 19.375ZM25.625 17.875C24.5204 17.875 23.625 18.7704 23.625 19.875V29.875C23.625 30.9796 24.5204 31.875 25.625 31.875H30.625C31.7296 31.875 32.625 30.9796 32.625 29.875V19.875C32.625 18.7704 31.7296 17.875 30.625 17.875H25.625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.375 29.875C11.375 29.4608 11.7108 29.125 12.125 29.125H24.125V30.625H12.125C11.7108 30.625 11.375 30.2892 11.375 29.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnClientsLight);
export default __webpack_public_path__ + "static/media/btn_clients_light.baebb8b9967fc1c3adf5105dabc41506.svg";
export { ForwardRef as ReactComponent };